import React, {useState, useEffect} from "react";
import classNames from "classnames";

import {input} from "../faux_data/augment_new";

//material-ui
import {withStyles} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import {lighten} from "@material-ui/core/styles/colorManipulator";
import Typography from "@material-ui/core/Typography";

import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
  container: {
    marginBottom: 0
  },
  table: {
    minWidth: 400,
    maxWidth: "auto",
  },
  head: {
    fontFamily: ["Rubik", "sans-serif"].join(","),
    backgroundImage:
      "linear-gradient(to right, #020d39, #012e58, #134e75, #307190, #5394a9);"
  },
  head_cell: {
    fontFamily: ["Rubik", "sans-serif"].join(","),
    color: "white",
    fontWeight: "600",
    fontSize: "1em"
  },
  cell: {
    fontWeight: "400",
    fontSize: "1em",
    fontFamily: ["Rubik", "sans-serif"].join(",")
  }
});


export default function BatchTable({inputId, activeStep}) {
  let columns = [
      {name: "origin", title: "Source"},
      {name: "sentence", title: "Augmented Sentences"}
    ];


  let input_data = input[inputId].augment;

  const batch_data = []
  input_data.map((inp, idx) => {
    if(inp.in_batch){
      batch_data.push(inp)
    }
  })

  const classes = useStyles();

  return (
    <TableContainer component={Paper} className={classes.container}>
      <Table className={classes.table} aria-label="cluster table">
        <TableHead className={classes.head}>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.name}
                align="center"
                className={classes.head_cell}
              >
                {column.title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {batch_data.map((row, i) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={i}
                align="left"
                value={row}
              >
                {columns.map((column, t) => (
                  <TableCell
                    className={classes.cell}
                    align="center"
                    key={t}
                  >
                    {row[column.name]}{" "}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
